<div class="multiple-tags">
  <div class="selected-label" *ngFor="let tag of tagsShown">
    <app-tag [tags]="tag"></app-tag>
  </div>
</div>
